//#region src/components/Avatar/useIdColorHash.ts
/**
* Determines a number for a given Matrix ID or room ID, helps disambiguating users
* who are trying to impersonate someone else.
* @param id - a Matrix ID or room ID
* @returns a hash of the ID provided
*/
function useIdColorHash(id) {
	return id.split("").reduce((sum, char) => {
		return sum + char.charCodeAt(0);
	}, 0) % 6 + 1;
}
//#endregion
export { useIdColorHash };

//# sourceMappingURL=useIdColorHash.js.map